
























































































































































































import Vue from 'vue'

import { parseSgf } from '@/utils/kifuParser'
import { Point } from '@/utils/Point'
import { kifuList } from '@/assets/kifuList'

const parsedKifuList = kifuList.map((kifu) => parseSgf(kifu)) as Kifu[]

type KifuTurn = { type: string; pt: Point }
type Kifu = {
  head: Record<string, string>
  turns: KifuTurn[]
}

const unitSize = 40

export default Vue.extend({
  data() {
    return {
      turnIndex: 0,
      turns: [] as KifuTurn[],
      blur: 3.9,
      stoneScale: 0.9,
      edgeScale: 0.2,
      useFilter: true,
      unitSize,
      kifuList: parsedKifuList,
      selectedKifu: parsedKifuList[0],
    }
  },
  computed: {
    turnsBlack(): KifuTurn[] {
      return this.turns
        .slice(0, this.turnIndex)
        .filter(({ type }) => type === 'B')
    },
    distanceBlack(): { index: number; distance: number }[][] {
      const distanceList = this.turnsBlack.map((turn, i, array) => {
        const list = array.slice(i + 1).map((target, j) => {
          return {
            index: i + j + 1,
            distance: turn.pt.getDistance(target.pt),
          }
        })
        return list
      })
      return distanceList
    },
    neighborsBlack(): { p0: Point; p1: Point; distance: number }[] {
      return this.distanceBlack.reduce(
        (
          acc: { p0: Point; p1: Point; distance: number }[],
          distanceList,
          i
        ) => {
          const list = distanceList.filter(
            ({ distance }) => 1 < distance && distance <= 5
          )

          return [
            ...acc,
            ...list.map((item) => {
              return {
                p0: this.turnsBlack[i].pt,
                p1: this.turnsBlack[item.index].pt,
                distance: item.distance,
              }
            }),
          ]
        },
        []
      )
    },
    turnsWhite(): KifuTurn[] {
      return this.turns
        .slice(0, this.turnIndex)
        .filter(({ type }) => type === 'W')
    },
    distanceWhite(): { index: number; distance: number }[][] {
      const distanceList = this.turnsWhite.map((turn, i, array) => {
        const list = array.slice(i + 1).map((target, j) => {
          return {
            index: i + j + 1,
            distance: turn.pt.getDistance(target.pt),
          }
        })
        return list
      })
      return distanceList
    },
    neighborsWhite(): { p0: Point; p1: Point; distance: number }[] {
      return this.distanceWhite.reduce(
        (
          acc: { p0: Point; p1: Point; distance: number }[],
          distanceList,
          i
        ) => {
          const list = distanceList.filter(
            ({ distance }) => 1 < distance && distance <= 5
          )

          return [
            ...acc,
            ...list.map((item) => {
              return {
                p0: this.turnsWhite[i].pt,
                p1: this.turnsWhite[item.index].pt,
                distance: item.distance,
              }
            }),
          ]
        },
        []
      )
    },
  },
  watch: {
    selectedKifu: {
      immediate: true,
      handler(val: Kifu) {
        this.turns = val.turns
        this.turnIndex = val.turns.length - 1
      },
    },
  },
  methods: {
    check() {
      // eslint-disable-next-line no-console
      console.log(this.neighborsBlack)
    },
  },
})
